import React from 'react';
import { ReactComponent as LayersIcon } from '@src/assets/icons/layers.svg';
import { ArcCheckbox, ArcCollapse, ArcIconButton, ArcStack, ArcText, ArcTooltip } from '@src/core/ui';
import { LayersProps } from './types';
import { useDispatch, useSelector } from 'react-redux';
import { selectDisplayZones, setDisplayZones } from '@src/core/features';
import { useDisclosure } from '@src/core/hooks';

const Layers: React.FC<LayersProps> = () => {
  const dispatch = useDispatch();
  const { open, toggle } = useDisclosure();

  const displayZones = useSelector(selectDisplayZones);

  return (
    <ArcStack alignItems='flex-end' sx={{ overflow: 'visible' }}>

      <ArcStack 
        width={50} 
        height={50} 
        borderRadius={2}
        alignItems='center' 
        justifyContent='center' 
        bgcolor='background.paper'>
        <ArcTooltip title='Layers'>
          <ArcIconButton onClick={toggle}>
            <LayersIcon />
          </ArcIconButton>
        </ArcTooltip>
      </ArcStack>

      <ArcCollapse in={open}>
        <ArcStack mt={1} py={1} pl={1} pr={2} borderRadius={2} bgcolor='background.paper' sx={{ boxShadow: 2 }}>
          <ArcStack direction='row' alignItems='center'>
            <ArcCheckbox 
              size='small' 
              color='brand'
              checked={displayZones}
              onChange={(_, value) => {
                dispatch(setDisplayZones(value));
              }} />
            <ArcText.h6> Zones </ArcText.h6>
          </ArcStack>
        </ArcStack>
      </ArcCollapse>
    </ArcStack>
  );
};

export default Layers;